module.exports = __webpack_public_path__ + "static/media/clipboard-user.7ae3cc51.svg";